import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-4 tw-bg-white tw-rounded-lg tw-shadow-[0px_0px_8px_0px_#0C0F4A14] tw-max-w-[412px]" }
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-flex-end" }
const _hoisted_3 = { class: "tw-flex tw-gap-2 tw-items-start" }
const _hoisted_4 = { class: "header_text tw-text-left" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tw-text-[12px] tw-font-[700] tw-text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-border-[0.25px] tw-border-solid tw-border-gray-100 tw-my-4" }, null, -1)
const _hoisted_8 = { class: "tw-flex tw-justify-between tw-mb-2 tw-gap-2 tw-text-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[14px] tw-font-[600] tw-text-[#0C0F4A]" }, " Property ", -1)
const _hoisted_10 = { class: "tw-text-[14px] tw-font-[600] tw-text-[#4F55F0] tw-text-left tw-max-w-[200px] tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap" }
const _hoisted_11 = { class: "tw-flex tw-justify-between tw-mb-2 tw-gap-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[14px] tw-font-[600] tw-text-[#0C0F4A]" }, " Time ", -1)
const _hoisted_13 = { class: "tw-text-[14px] tw-font-[600] tw-text-[#4F55F0]" }
const _hoisted_14 = { class: "tw-flex tw-justify-between tw-mb-2 tw-gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[14px] tw-font-[600] tw-text-[#0C0F4A]" }, " Date ", -1)
const _hoisted_16 = { class: "tw-text-[14px] tw-font-[600] tw-text-[#4F55F0]" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-border-[0.25px] tw-border-solid tw-border-gray-100 tw-my-4" }, null, -1)
const _hoisted_18 = { class: "tw-text-[12px] tw-font-[400] tw-text-[#0C0F4ACC] tw-text-left tw-flex" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "tw-flex tw-gap-3 tw-mt-2" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-border-[0.25px] tw-border-solid tw-border-gray-100 tw-my-4" }, null, -1)
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-border-[0.25px] tw-border-solid tw-border-gray-100 tw-my-4" }, null, -1)

import countDownSvg from "@/core/uni-assets/svgs/countdown.svg";
import { SiteVisitStatus } from "@/core/enums/estimateEnum";
import moment from "moment";
import { ref } from "vue";
import { onMounted } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";
import Button from "./Button.vue";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import Text from "@/core/components/ui/general/Text.vue";
import { getImageApiUrl } from "../utils/common";
import $axios from "@/core/utils/axios-api-config";
import RejectSiteRequestDialog from "./RejectSiteRequestDialog.vue";
import { useRouter } from "vue-router";
import { WORKSTATION } from "@/store/modules/workstation";
import { PROPERTY_STORE } from "@/store/modules/property";

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteVisitCard',
  props: {
  visitData: {
    type: Object,
  },
  typeData: {
    type: String,
  },
  projectRefId: {
    type: String,
  },
},
  emits: ["get-all-request"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const requestStatus = ref(0);
const store = useStore();
const isLoading = ref(false);
const isShowRejectModal = ref(false);
const props = __props;
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const isRejectLoading = ref(false);
const formatTime = (hours: number, minutes: number) => {
  return moment({ hours, minutes }).format("hh:mm A");
};

const getWorkstationName = (name: any) => {
  return name.length > 25 ? `${name.slice(0, 25)}...` : name;
};
const emits = __emit;
const formatTimeRang = (timeArray: any) => {
  timeArray = JSON.parse(timeArray);
  const startTime = formatTime(timeArray[0].hours, timeArray[0].minutes);
  const endTime = formatTime(timeArray[1].hours, timeArray[1].minutes);
  return `${startTime} to ${endTime}`;
};
const getStatus = computed(() => {
  if (requestStatus.value === SiteVisitStatus.REJECTED) {
    return "Rejected";
  } else if (requestStatus.value === SiteVisitStatus.ACCEPTED) {
    return "Accepted";
  } else {
    return "Requested";
  }
});

const updateRequest = async (
  status: SiteVisitStatus,
  rejectionReason = "",
  rejectionMessage = ""
) => {
  const formData = {
    status,
    rejectionReason,
    rejectionMessage,
  } as any;
  try {
    isLoading.value = true;
    const response = await store.dispatch(
      `${JOB_TEMPLATE_STORE}/updateSiteRequest`,
      {
        siteVisitId: parseInt(props.visitData?.id),
        formData,
      }
    );

    if (response) requestStatus.value = response?.status;

    if (response && SiteVisitStatus.CANCELED == status) {
      emits("get-all-request");
    }
    isLoading.value = false;
  } catch (error) {
    console.log();
    isLoading.value = false;
  }
};
const imageUrl = ref(null);

const openRejectModal = () => {
  isShowRejectModal.value = true;
};
const onCancelRejectSiteModal = () => {
  isShowRejectModal.value = false;
};
const onConfirmRejectSiteModal = async (payload: any) => {
  isRejectLoading.value = true;
  try {
    const { rejectionReason, rejectionMessage } = payload;
    await updateRequest(
      SiteVisitStatus.REJECTED,
      rejectionReason,
      rejectionMessage
    );
    isShowRejectModal.value = false;
    isRejectLoading.value = false;
  } catch (error) {
    console.log(error);
    isRejectLoading.value = false;
  }
};

const onClickVisitProperty = async () => {
  store.commit(`${PROPERTY_STORE}/setIsSiteVisitPropertyDetail`, true);
  store.commit(
    `${PROPERTY_STORE}/setSiteVisitProjectRefId`,
    props.projectRefId
  );
  await router.push({
    name: "propertyDetails",
    params: { propertyId: props.visitData?.property?.id },
  });
};
onMounted(async () => {
  requestStatus.value = props.visitData?.status;
  try {
    const imageApiUrl = getImageApiUrl(
      props?.visitData?.workStation?.profileImage,
      true
    );
    const encoded = await $axios.get(imageApiUrl);
    imageUrl.value = encoded.publicUrl;
  } catch (error) {
    console.log();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProfileThumbnail, { src: imageUrl.value }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Text, {
            whiteSpace: "nowrap",
            variant: "h6",
            class: "tw-block tw-text-[rgba(44, 62, 80, 0.5)] tw-overflow-ellipsis tw-overflow-hidden tw-max-w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getWorkstationName(__props.visitData?.workStation?.name)), 1)
            ]),
            _: 1
          }),
          _createVNode(Text, {
            class: "xs-fs-12",
            textColor: "rgba(12, 15, 74, 0.5)"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.visitData?.workStation?.workstationAccountType?.code), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tw-max-w-[94px] tw-flex tw-justify-between tw-items-center tw-p-2 tw-rounded-md tw-gap-1 tw-h-[24px] status-bagde", getStatus.value])
      }, [
        _createElementVNode("img", {
          src: _unref(countDownSvg),
          class: "tw-w-[12px] tw-h-[12px]"
        }, null, 8, _hoisted_5),
        _createElementVNode("span", _hoisted_6, _toDisplayString(getStatus.value), 1)
      ], 2)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("span", _hoisted_10, _toDisplayString(__props.visitData?.property?.address), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("span", _hoisted_13, _toDisplayString(formatTimeRang(__props.visitData?.startTime)), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("span", _hoisted_16, _toDisplayString(__props.visitData?.date), 1)
    ]),
    _hoisted_17,
    _createElementVNode("span", _hoisted_18, _toDisplayString(__props.visitData?.description ? __props.visitData?.description : ""), 1),
    (__props.typeData === 'Project' && requestStatus.value === _unref(SiteVisitStatus).DEFAULT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Button, {
              label: "Reject",
              onClick: openRejectModal,
              class: "!tw-w-1/2 md:!tw-w-full button button-purple-border"
            }),
            _createVNode(Button, {
              class: "button button-orange !tw-w-1/2 md:!tw-w-full",
              variant: "text",
              label: "Accept",
              loading: isLoading.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (updateRequest(_unref(SiteVisitStatus).ACCEPTED)))
            }, null, 8, ["loading"])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.typeData === 'Job' && requestStatus.value === _unref(SiteVisitStatus).DEFAULT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(Button, {
            variant: "primary",
            label: "Cancel",
            loading: isLoading.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateRequest(_unref(SiteVisitStatus).CANCELED)))
          }, null, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    (__props.typeData === 'Job' && requestStatus.value === _unref(SiteVisitStatus).ACCEPTED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(Button, {
            variant: "primary",
            label: "VISIT PROPERTY",
            color: "#4F55F0",
            onClick: onClickVisitProperty
          })
        ]))
      : _createCommentVNode("", true),
    (isShowRejectModal.value)
      ? (_openBlock(), _createBlock(RejectSiteRequestDialog, {
          key: 3,
          isLoading: isRejectLoading.value,
          onOnCancel: onCancelRejectSiteModal,
          onOnConfirm: onConfirmRejectSiteModal
        }, null, 8, ["isLoading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})